import { Component } from '@angular/core';
import { ButtonColor } from '@freelancer/ui/button';

@Component({
  selector: 'app-navigation-secondary-finances',
  template: `
    <app-bar flTrackingSection="SubnavFinances">
      <app-bar-item
        link="/users/financial-dash"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="Finances"
      >
        Finances
      </app-bar-item>
      <app-bar-item
        link="/payments/transactions.php"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="TransactionHistory"
      >
        Transaction History
      </app-bar-item>
      <app-bar-item
        link="/payments/verify.php"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="VerifyPaymentMethod"
      >
        Verify Payment Method
      </app-bar-item>
      <app-bar-item
        link="/deposit"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="DepositFunds"
      >
        Deposit Funds
      </app-bar-item>
      <app-bar-item
        link="/payments/withdraw.php"
        [exactLink]="true"
        i18n="Secondary navigation finances bar item"
        flTrackingLabel="WithdrawMoney"
      >
        Withdraw Money
      </app-bar-item>
    </app-bar>
  `,
})
export class NavigationSecondaryFinancesComponent {
  ButtonColor = ButtonColor;
}
